import { api } from './client';

export interface AppConfig {
  siteName: string;
  defaultLanguage: string;
  googleEnabled: boolean;
  billingEnabled: boolean;
  stripePublishableKey: string | null;
  /** Null when unconfigured; the help page then hides its contact block entirely. */
  supportEmail: string | null;
  /**
   * What may be loaded once a visitor agrees to it. Null when no tag is configured, in which case
   * there is no consent banner either — there would be nothing to consent to.
   */
  tracking: TrackingConfig | null;
}

/** Public identifiers from the `Tracking` section of appsettings.json. */
export interface TrackingConfig {
  googleAnalyticsId: string | null;
  googleAdsId: string | null;
  /** Event name to Google Ads conversion label, for the events that have one. */
  conversions: Partial<Record<string, string>>;
}

export const configApi = {
  get: () => api<AppConfig>('/api/config'),
};
